module.exports = __webpack_public_path__ + "static/img/fnb-app-order.17d38d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/fnb-app-order.svg
// module id = 1000
// module chunks = 34